<template>
  <div v-loading.fullscreen="loading">
    <div v-if="!loading">
      <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'positionList' }">{{$t('entities.position.plural')}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="editing && model" :to="{ name: 'positionShow', params: { id: model.id } }">{{ model.name }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="editing">{{$t('table.edit')}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="!editing">{{$t('table.add')}}</el-breadcrumb-item>
      </el-breadcrumb>

      <h2 class="page-title"> {{ editing ? $t('table.edit') + ' ' + $t('entities.position.singular') : $t('table.add') + ' ' + $t('entities.position.singular') }}</h2>

      <el-form
        ref="form"
        :model="model"
        :label-position="labelPosition"
        :label-width="labelWidth"
        :rules="rules"
        @submit.native.prevent="save"
      >
        <div class="block">
        <el-form-item label="Name" prop="name">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input
              v-model="model.name"
            ref="focus"
            />
          </el-col>
        </el-form-item>
        </div>

        <div class="button-group mt-3">
          <el-button
            @click="save()"
            :disabled="loading"
            type="primary"
            icon="el-icon-fa-floppy-o"
          >
            Save
          </el-button>
          <el-button
            @click="back()"
            :disabled="loading"
            icon="el-icon-fa-times"
          >
            Cancel
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import validators from '@/shared/form/validators';

export default {
  name: 'app-position-form',

  props: {
    id: String,
    previous: String,
  },

  data() {
    return {
      rules: {
        name: validators.string({
          label: 'Name',
          required: true
        }),
      },
    };
  },

  created() {
    if (this.id) {
      this.$store
        .dispatch('entities/position/edit', this.id)
        .catch(() =>
          this.$router.push({ name: 'positionList' }),
        );
    } else {
      this.$store.dispatch('entities/position/new');
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/position/clear');
    next();
  },

  computed: {
    ...mapGetters({
      model: 'entities/position/model',
      loading: 'entities/position/loading',
      labelPosition: "shared/labelPosition",
      labelWidth: "shared/labelWidth",

    }),

    editing: state => !!state.id,
  },

  methods: {
    save() {
      this.$refs.form.validate().then(valid => {
        if (!valid) {
          return;
        }

        this.$store
          .dispatch('entities/position/save')
          .then(() => {
            this.back();
          });
      });
    },

    back() {
      if (this.previous === 'show') {
        this.$router.push({
          name: 'positionShow',
          params: { id: this.id },
        });
        return;
      }

      this.$router.push({ name: 'positionList' });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/position/position-form.vue?1a8b9a74